import { Avatar, Card, List, Space, Typography } from "antd";
import { EmptyState } from "../EmptyState";
import type { CommentItem } from "./types";

interface CommentsTabProps {
  comments: CommentItem[];
}

export default function CommentsTab({ comments }: CommentsTabProps) {
  const sorted = [...comments].sort((a, b) => {
    const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return tb - ta;
  });

  return (
    <Card title="Comments & Activity">
      {sorted.length === 0 ? (
        <EmptyState description="No comments or activity yet. Status changes will appear here automatically." />
      ) : (
        <List
          aria-label="Project comments and activity log"
          dataSource={sorted}
          renderItem={(comment) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar>{comment.author?.[0] || "U"}</Avatar>}
                title={
                  <Space size="small">
                    <Typography.Text strong>
                      {comment.author || "User"}
                    </Typography.Text>
                    {comment.createdAt && (
                      <Typography.Text type="secondary">
                        {new Date(comment.createdAt).toLocaleString()}
                      </Typography.Text>
                    )}
                  </Space>
                }
                description={
                  <Typography.Paragraph style={{ marginBottom: 0 }}>
                    {comment.message}
                  </Typography.Paragraph>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
}
